// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popover_popover__27A1r","overlay":"Popover_overlay__3CVH_"};